function addMinutesToDate(date, minutes) {
  const dateCopy = new Date(date);
  dateCopy.setMinutes(date.getMinutes() + minutes);
  return dateCopy;
}

function formatTimeNumber(time) {
  return time.toString().padStart(2, '0');
}

function timerCountdown(counterEl, minutes) {
  const counter = document.getElementById(counterEl);

  // Set the date we're counting down from
  const date = new Date();

  // Set the date we're counting down to
  const countDownDate = addMinutesToDate(date, minutes).getTime();

  // Update the count down every 1 second
  const timer = setInterval(function () {
    // Get today's date and time
    const now = new Date().getTime();

    // Find the distance between now and the count down date
    const distance = countDownDate - now;
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    counter.style.display = 'block';
    counter.style.padding = '14px';
    counter.style.backgroundColor = '#f0f0f0';
    counter.innerHTML = `Aguarde ${formatTimeNumber(minutes)}:${formatTimeNumber(seconds)} para solicitar um novo código de acesso.`;

    if (distance < 0) {
      clearInterval(timer);
      counter.style.display = 'none';
    }
  }, 1000);
}

export default timerCountdown;
